import { useMemo } from "react";
import { useTranslations } from "next-intl";
import { SCard } from "@/components/Card/SCard";
import { Spacing } from "@/components/Spacing/Spacing";
import { AuthLayout } from "./AuthLayout";
import MfaSetupContent from "./mfa-setup/MfaSetupContent";
import { useAuth } from "@/lib/auth/AuthContext";

export function MfaSetupPage() {
  const t = useTranslations("mfaSetup");
  const { state } = useAuth();
  const initialTimeRemaining = useMemo(() => {
    // MFA-pending access cookie is HttpOnly; backend ships the expiry
    // epoch via mfaExpiresAt on the login response, surfaced in the
    // mfa-required auth state.
    if (state.kind !== "mfa-required") return 300;
    return Math.max(0, Math.floor((state.mfaExpiresAt - Date.now()) / 1000));
  }, [state]);

  return (
    <AuthLayout>
      <SCard header={t("title")} outline="outline-quaternary" shadow="shadow-xl">
        <Spacing height="h-6" />
        <MfaSetupContent initialTimeRemaining={initialTimeRemaining} />
      </SCard>
    </AuthLayout>
  );
}
